<style>
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .custom-spinner {
    animation: spin 1s linear infinite;  /* Hier wird das Icon rotiert */
  }
  .type-ahead-search-input-bar {
    position: relative;
    flex-grow: 1;
  }
  .ta-search-reset {
    z-index: 1;
    position: absolute;
    right: calc(1rem - 4px);
    top: .5rem;
    cursor: pointer;
  }
  .ta-search-left {
    z-index: 1;
    position: absolute;
    top: .5rem;
    left: calc(1rem - 4px);
    line-height: 1rem;
  }
  .ta-search-input {
    background-color: var(--search-background-color-50);
    border: 2px solid var(--c-neutral-600);
    box-sizing: border-box;
    padding: 6px 30px 6px 40px;
    width: 100%;
    font-size: 1rem;
    line-height: 1rem;
    border-radius: 1rem;
    outline: none;
    transition: 300ms ease background-color;
  }
  .ta-search-inputted:hover, .ta-search-input:hover {
    background-color: var(--search-background-color-100);
  }
  .ta-search-inputted:focus, .ta-search-input:focus {
    background-color: var(--search-background-color-50);
  }
  .ta-search-inputted {
    background-color: var(--search-background-color-50);
    border: 2px solid var(--c-neutral-600);
    box-sizing: border-box;
    padding: 6px 30px 6px 40px;
    width: 100%;
    font-size: 1rem;
    line-height: 1rem;
    outline: none;
    transition: background-color 300ms, border-radius 300ms;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    border-bottom: 2px solid var(--c-neutral-800);
  }
  .ta-result {
    position: absolute;
    border: 2px solid var(--c-neutral-700);
    height: auto;
    max-height: 30vh;
    width: 100%;
    overflow: auto;
    z-index: 4;
  }
  .ta-result-row {
    position: relative;
    z-index: 5;
    padding: 6px 8px 6px 40px;
    background-color: var(--c-ctrl-text-inverse);
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .ta-result-empty {
    position: relative;
    z-index: 5;
    padding: 6px 8px 6px 40px;
    background-color: var(--c-ctrl-text-inverse);
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .ta-locked {
    background-color: var(--c-neutral-500);
    border: 2px solid var(--c-neutral-600);
    box-sizing: border-box;
    padding: 6px 30px 6px 40px;
    width: 100%;
    font-size: 1rem;
    line-height: 1rem;
    border-radius: 1rem;
    outline: none;
    transition: 300ms ease background-color;
  }
  .ta-result-more {
    position: relative;
    z-index: 5;
    padding: 6px 8px 6px 40px;
    background-color: var(--c-ctrl-text-inverse);
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .ta-result-more:hover, .ta-result-row:hover, .ta-result-more:focus, .ta-result-row:focus  {
    background-color: var(--c-neutral-500);
    cursor: pointer;
    outline: none;
  }

</style>
<div style="position: relative" class="type-ahead-search-input-bar">
  <input    #inputElement
            (keydown.arrowdown)="onArrowDown($event, -1)"
    *ngIf="!returnValue && !isLocked; else elseBlock"
    type="text" [ngClass]="(searchValue && !returnValue) ? 'ta-search-inputted' : 'ta-search-input'"
    name="{{outputAttribute}}"
    [(ngModel)]="searchValue"
    placeholder="{{searchPlaceholder}}">
  <ng-template #elseBlock>
    <div *ngIf="returnValue" [ngClass]="{ 'ta-locked' : deleteIsLocked,  'ta-search-input': !deleteIsLocked}">
      {{returnValue[listdisplay]}}
    </div>
    <div *ngIf="!returnValue" class="ta-locked">
      &nbsp;
    </div>
  </ng-template>
  <i *ngIf="!returnValue && data.state !== 1" tabindex="-1" class="ta-search-left fas fa-search"></i>
  <i *ngIf="data.state === 1" class="ta-search-left fas fa-spinner custom-spinner"></i>
  <!--reset Search Value-->
  <i *ngIf="searchValue && !returnValue" (click)="deleteSearchValue()" tabindex="-1" class="ta-search-reset fas fa-times"></i>
  <!--reset chosen Value-->
  <i *ngIf="returnValue && !deleteIsLocked" (click)="deleteChosenObject()" tabindex="0"
     (keydown.enter)="deleteChosenObject()" class="ta-search-reset fas fa-times"></i>


  <!--Results, only top 5 unless show more-->
  <div class="content ta-result" *ngIf="this.searchValue && data.showResults">
    <ng-container *ngFor="let item of data.data.slice(0, data.maxResultCount); let i = index">
      <div #listRow class="list-row ta-result-row"
           tabindex="0"
           (keydown.enter)="onResultClick(item)"
           (keydown.arrowup)="onArrowUp($event, i)"
           (keydown.arrowdown)="onArrowDown($event, i)"
           (click)="onResultClick(item)">
        {{ item[listdisplay] }}
      </div>
    </ng-container>
    <!-- Nur anzeigen, wenn mehr als 5 Elemente vorhanden sind -->
    <div #showMore *ngIf="data.data.length > data.maxResultCount" tabindex="0"
         (keydown.enter)="onShowMore()"
         (click)="onShowMore()"
         class="list-row ta-result-more">
      <i>Mehr anzeigen ({{data.data.length - data.maxResultCount }})</i>
    </div>
    <!-- Nur anzeigen, wenn keine Elemente vorhanden sind -->
    <div *ngIf="data?.data?.length === 0 && data.state !== 1"
         class="list-row ta-result-empty">
      <i>Keine Ergebnisse</i>
    </div>
  </div>

</div>


